/*
  Project: Edge
  Author: Xfive
 */

import 'classlist-polyfill';
import arrayFrom from 'array-from';
import objectAssign from 'object-assign';
import AnchorScroll from './AnchorScroll';
import Navigation from './Navigation';
import StickyTop from './StickyTop';
import ExhibitionModal from './ExhibitionModal';
import HeroCarousel from './HeroCarousel';
import HeroIframe from './HeroIframe';
import Translate from './Translate';
import Header from './Header';
import ParallaxScroll from './ParallaxScroll';

if (!Object.assign) {
  Object.assign = objectAssign;
}

if (!Array.from) {
  Array.from = arrayFrom;
}

new AnchorScroll();
new Navigation();
new ExhibitionModal();
new StickyTop();
new HeroCarousel();
new HeroIframe();
new Translate();
new Header();
new ParallaxScroll();
